var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui icon message"},[_c('i',{staticClass:"notched circle loading icon"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"header"},[_vm._v(" Einen Augenblick bitte.. ")]),_c('p',[_vm._v("Wir laden den Inhalt..")])])])
}]

export { render, staticRenderFns }